import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription, firstValueFrom } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';
import { ChunkService } from 'src/app/views/content/chunk/chunk.service';
import { ContentService } from 'src/app/views/content/content.service';
import { CourseCreatorService } from 'src/app/views/displayer/course-creator/course-creator.service';
import { MySpaceService } from 'src/app/views/my-space/my-space.service';
import { MaterialModule } from '../../material.module';
import { AddSectionComponent } from '../../services/add-section/add-section.component';
import { AppConfirmService } from '../../services/app-confirm/app-confirm.service';
import { ToastService } from '../../services/toast/toast.service';
import { ShareMenuDialogComponent } from '../share-menu-dialog/share-menu-dialog.component';
import { BlogCardData } from './blog-card.dto';

@Component({
  selector: 'blog-card',
  templateUrl: './blog-card.component.html',
  standalone: true,
  imports: [MaterialModule, RouterModule, TranslateModule],
})
export class BlogCardComponent implements OnInit, OnDestroy {
  @Input() post: BlogCardData;
  @Input() createMode;
  @Output() reloadList = new EventEmitter<any>();
  private translateSub: Subscription;
  private userInfoSub: Subscription;
  isBlogAdmin;
  constructor(
    private dialog: MatDialog,
    private courseCreatorService: CourseCreatorService,
    private confirmService: AppConfirmService,
    private toast: ToastService,
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private bottomSheet: MatBottomSheet,
    private auth: AuthService,
    private mySpaceService: MySpaceService,
    private appService: AppService,
    private contentService: ContentService,
    private chunkService: ChunkService,
    private confirm: AppConfirmService,
    private router: Router
  ) {
    this.translateSub = this.translate.onLangChange.subscribe((params) => {
      // this.getBlogNameAndDescChunkMainEditions()
    });
  }

  ngOnInit() {
    this.userInfoSub = this.auth.userInfo$.subscribe((userInfo) => {
      const userID = userInfo.id;
      this.isBlogAdmin = (this.post.users.find((e) => e._id === userID) || {}).role === 'Admin';
    });
    // this.getBlogNameAndDescChunkMainEditions()
  }
  ngOnDestroy() {
    this.translateSub.unsubscribe();
    this.userInfoSub.unsubscribe();
  }

  navigate(): void {
    this.router.navigate(['/articles', this.post._id]);
  }

  archiveBlog(blogID) {
    this.confirmService.confirm({ message: this.translate.instant('Confirm.ArchiveBlog') }).subscribe((res) => {
      if (res) {
        this.mySpaceService.addToArchive({ blogID }).subscribe(() => {
          this.reloadList.emit();
        });
      }
    });
  }
  generateContentEmbedding(contentID) {
    this.contentService.generateContentEmbeddingAction(contentID);
  }
  openShareMenu(blogID) {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');

    if (isSmallScreen) {
      this.bottomSheet.open(ShareMenuDialogComponent, {
        data: {
          blogID,
        },
      });
    } else {
      this.dialog.open(ShareMenuDialogComponent, {
        width: '500px',
        maxHeight: '80vh',
        data: {
          blogID,
        },
      });
    }
  }

  openDialog(type, blogID) {
    this.dialog
      .open(AddSectionComponent, {
        data: {
          type,
          blogID,
        },
        width: '500px',
      })
      .afterClosed()
      .subscribe((res) => {
        if (res === 'ok') {
          this.reloadList.emit();
        }
      });
  }

  deleteBlog(blogID, blogName) {
    this.translate.get('Global.Delete').subscribe((delString) => {
      this.confirmService.confirm({ message: `${delString} ${blogName}?` }).subscribe({
        next: (res) => {
          if (res) {
            this.courseCreatorService.deleteBlogPost(blogID).subscribe({
              next: () => {
                this.toast.snackbar.open(this.translate.instant('Snackbar.BlogDeletedSuccess'), 'OK', { duration: 4000 });
                this.reloadList.emit();
              },
              error: (err) => {
                this.toast.snackbar.open(this.translate.instant('Snackbar.BlogDeletedFail'), 'OK', { duration: 4000 });
                console.error(err);
              },
            });
          }
        },
        error: () => {
          this.toast.snackbar.open(this.translate.instant('Snackbar.BlogDeletedFail'), 'OK', { duration: 4000 });
        },
      });
    });
  }
  async encryptContent(contentID) {
    const response = await firstValueFrom(this.confirm.confirm());
    if (!response) {
      return;
    }
    this.chunkService.encryptContent({ contentID }).subscribe({
      next: () => {
        this.reloadList.emit();

        this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
          duration: 2000,
        });
      },
    });
  }
  async decryptContent(contentID) {
    const response = await firstValueFrom(this.confirm.confirm());
    if (!response) {
      return;
    }
    this.chunkService.decryptContent({ contentID }).subscribe({
      next: () => {
        this.reloadList.emit();

        this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
          duration: 2000,
        });
      },
    });
  }
}
